import {User} from '@gauged/gauged-js';

import {useAppSelector} from 'store';
import {selectCurrentUser} from 'features/currentUser/currentUserSlice';

export const useCurrentUser = () => {
    return useAppSelector(selectCurrentUser) as User | null;
}
